function getLocationOrigin() {
  return eval("window.location.origin");
}

export var resolvePathToBackendURI = function resolvePathToBackendURI(endpoint) {
  // If someone's using gitpod, then use dynamic host
  var isCrusherBackend = process.env.NEXT_PUBLIC_INTERNAL_BACKEND_URL.includes("crusher.dev");
  var isGitpodDevEnv = true && window.location.origin.includes("gitpod");

  if (!isCrusherBackend && isGitpodDevEnv) {
    return getPathWithHost("".concat(getLocationOrigin(), "/server"), endpoint);
  }

  return getPathWithHost(process.env.NEXT_PUBLIC_INTERNAL_BACKEND_URL || "".concat(getLocationOrigin(), "/server"), endpoint);
};
export var resolvePathToFrontendURI = function resolvePathToFrontendURI(endpoint) {
  return getPathWithHost(getLocationOrigin(), endpoint);
};

var getPathWithHost = function getPathWithHost(host, path) {
  var isBackslashPresent = host.split("")[host.length - 1] === "/";
  var hostName = isBackslashPresent ? host.slice(0, -1) : host;
  return hostName + path;
};

export function appendParamsToURI(url) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var currentURL = new URL(url);

  for (var _i = 0, _Object$keys = Object.keys(params); _i < _Object$keys.length; _i++) {
    var _paramKey = _Object$keys[_i];
    currentURL.searchParams.append(_paramKey, params[_paramKey]);
  }

  return currentURL.href;
}
export function addQueryParamToPath(uri, params) {
  return params ? "".concat(uri, "?").concat(params) : String(uri);
}
export function checkIfAbsoluteURI(uri) {
  var rgx = /^https?:\/\//i;
  return rgx.test(uri);
}
export function getAbsoluteURIIfRelative(uri) {
  var isAbsolute = checkIfAbsoluteURI(uri);

  if (!isAbsolute) {
    uri = resolvePathToBackendURI(uri);
  }

  return uri;
}